import { QBox, QFlex } from '@qualio/ui-components';
import { ImageDocumentViewerV2 } from './DocumentViewers/ImageDocumentViewerV2';
import { PDFDocumentViewerV2 } from './DocumentViewers/PDFDocumentViewerV2';

import styles from '../../DocumentLayout/DocumentLayout.module.css';
import { QualioAttachmentPreview } from '../hooks/useAttachmentPreview';
import { FileDocumentCommentsSidebar } from './FileDocumentCommentSidebar';

export const FileDocumentLayout: React.FC<{
  attachmentPreview: QualioAttachmentPreview;
  isPaginated: boolean;
  pageNumber: number;
  isXlsx: boolean;
  zoom: number;
  showComments: boolean;
  onLoadSuccess: (pageCount: number) => void;
  handleSessionDisconnectionEvent?: (didReceive: boolean) => void;
}> = ({
  attachmentPreview,
  pageNumber,
  isPaginated,
  isXlsx,
  zoom,
  showComments,
  handleSessionDisconnectionEvent,
  onLoadSuccess,
}) => {
  return (
    <QFlex
      data-cy="fileDocumentContent"
      flexGrow={1}
      justifyContent="space-between"
      bg="gray.50"
      border="1px"
      borderTop="1px"
      borderColor="gray.200"
      borderRadius="4px"
      className={`${styles['document-content-container']}`}
      overflow="hidden"
      padding={3}
    >
      {!isXlsx && (
        <QFlex
          flexGrow={1}
          flexBasis={200}
          minWidth={0}
          maxWidth={322}
          overflow="hidden"
        >
          <QBox width={'100%'} />
        </QFlex>
      )}
      <QFlex flexGrow={1} flexShrink={1} minWidth={802}>
        {attachmentPreview.previewType === 'document' && (
          <PDFDocumentViewerV2
            attachmentPreview={attachmentPreview}
            isPaginated={isPaginated}
            pageNumber={pageNumber}
            zoom={zoom}
            isXlsx={isXlsx}
            onLoadSuccess={onLoadSuccess}
          />
        )}
        {attachmentPreview.previewType === 'image' && (
          <ImageDocumentViewerV2
            zoom={zoom}
            attachmentPreviewUrl={attachmentPreview.url!}
          />
        )}
      </QFlex>
      <QFlex
        direction="column"
        flexGrow={1}
        flexBasis={200}
        minWidth={0}
        maxWidth={322}
        overflow="hidden"
      >
        {showComments && (
          <FileDocumentCommentsSidebar
            attachmentPreview={attachmentPreview}
            handleSessionDisconnectionEvent={handleSessionDisconnectionEvent}
          />
        )}
      </QFlex>
    </QFlex>
  );
};
